// components
import { styled, Box, TableRow } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export const StyledPreferredEmployeesBox = styled(Box)(({ theme }) => ({
  '.employee-selector': {
    marginBottom: '15px'
  },

  '& .MuiTable-root': {
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden'
  },

  '& .MuiTableCell-root': {
    padding: theme.spacing(1, 2),
    fontSize: theme.typography.body1.fontSize
  },

  '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
    backgroundColor: theme.palette.background.default
  }
}));

export const StyledIcon = styled(Icon)(({ theme }) => ({
  marginTop: theme.spacing(0.5)
}));

export const StyledPreferredEmployeesTableRow = styled(TableRow)(() => ({
  '&:last-child td, &:last-child th': { border: 0 }
}));

export const StyledOverflowXScrollBox = styled(Box)(() => ({
  overflowX: 'scroll'
}));
